import styled from 'styled-components';
import SquareButton, { SquareButtonProps } from './square-button';

const RoundButton = styled(SquareButton)<SquareButtonProps>`
  border-radius: 50%;
`;

export default RoundButton;
